import { DateTime, Duration } from "luxon";

import type { UserId } from "@core/domains/identity";
import type { Stage } from "@core/foundation/stage";
import type { JwtSignerContract } from "@core/ports/signing";

import { OAuthClaimsSchema } from "../../models/index.ts";

export const OAUTH_ACCESS_TOKEN_LIFETIME = Duration.fromObject({ hours: 1 });

export class OAuthJwtSigner {
  private readonly signer: JwtSignerContract;

  private readonly stage: Stage;

  public constructor({
    signer,
    stage,
  }: { readonly signer: JwtSignerContract; readonly stage: Stage }) {
    this.signer = signer;
    this.stage = stage;
  }

  public async sign({
    clientId,
    principalId,
    resource,
    scopes,
  }: {
    readonly clientId: string;
    readonly principalId: UserId;
    readonly resource: string;
    readonly scopes: readonly string[];
  }): Promise<string> {
    const utcNow = DateTime.utc();

    const now = Math.floor(utcNow.toSeconds());

    const exp = Math.floor(
      utcNow.plus(OAUTH_ACCESS_TOKEN_LIFETIME).toSeconds(),
    );

    const payload = OAuthClaimsSchema.decode({
      aud: resource,
      clientId,
      exp,
      iat: now,
      id: principalId,
      ...(scopes.length > 0 ? { scope: scopes.join(" ") } : {}),
      stage: this.stage,
      type: "oauth",
      version: 1,
    });

    return this.signer.sign(payload);
  }
}
